module.exports = __webpack_public_path__ + "fonts/Graphik-LightItalic-Web.15c4aa9.woff";